import apiClient from "../utils/apiClient";

import { getHeaderKeys } from "../utils/getHeaderKeys";

const headers = ["user-zip"];

const useHttp = () => {
  const getListings = async (query = "") => {
    try {
      const response = await apiClient.get(`listings?${query}`, {
        headers: {
          ...getHeaderKeys(headers),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error getting listings: ", error);
      throw error;
    }
  };

  const getGroupListings = async (query = "") => {
    try {
      const response = await apiClient.get(
        `products/products_listings?${query}`,
        {
          headers: {
            ...getHeaderKeys(headers),
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error getting group listings: ", error);
      throw error;
    }
  };

  const getPriceHistory = async (query = "") => {
    try {
      const response = await apiClient.get(`products/price_history?${query}`, {
        headers: {
          ...getHeaderKeys(headers),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error getting products: ", error);
      throw error;
    }
  };

  const getProducts = async (query = "") => {
    try {
      const response = await apiClient.get(`products?${query}`, {
        headers: {
          ...getHeaderKeys(headers),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error getting products: ", error);
      throw error;
    }
  };

  const getCalibers = async () => {
    try {
      const response = await apiClient.get(`/category_calibers`);

      return response.data.response;
    } catch (error) {
      console.error("Error getting calibers: ", error);
      throw error;
    }
  };

  const getBrands = async (brandId = "") => {
    try {
      const response = await apiClient.get(`brand_calibers?brandid=${brandId}`);

      return response.data.response;
    } catch (error) {
      console.error("Error getting brands: ", error);
      throw error;
    }
  };

  const getSearch = async (query = "") => {
    try {
      const response = await apiClient.get(`search${query}`, {
        headers: {
          ...getHeaderKeys(headers),
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error getting products: ", error);
      throw error;
    }
  };

  const getCaliberSEO = async (caliber = "") => {
    try {
      const response = await apiClient.get(
        `/seo/caliber_page_seo?seocaliber=${caliber}`,
      );

      return response.data;
    } catch (error) {
      console.error("Error getting caliber SEO:", error);
      throw error;
    }
  };

  const getProductSEO = async (productId = "") => {
    try {
      const response = await apiClient.get(
        `/seo/product_page_seo?pgid=${productId}`,
      );

      return response.data;
    } catch (error) {
      console.error("Error getting product SEO: ", error);
      throw error;
    }
  };

  const getBrandSEO = async (brandId = "") => {
    try {
      const response = await apiClient.get(
        `/seo/brand_page_seo?brand=${brandId}`,
      );

      return response.data;
    } catch (error) {
      console.error("Error getting brand SEO: ", error);
      throw error;
    }
  };

  const getBrandCaliberSEO = async (brandId = "", caliber = "") => {
    try {
      const response = await apiClient.get(
        `/seo/brand_caliber_page_seo?brand=${brandId}&caliber=${caliber}`,
      );

      return response.data;
    } catch (error) {
      console.error("Error getting brand SEO: ", error);
      throw error;
    }
  };

  const postMessage = async (data) => {
    try {
      const response = await apiClient.post("/Emails/contact", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return new Promise((resolve) => resolve(response.data));
    } catch (error) {
      console.error("Error getting products: ", error);
      return new Promise((reject) => reject(error));
    }
  };

  const postVendorForm = async (data) => {
    try {
      const response = await apiClient.post("/Emails/register", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return new Promise((resolve) => resolve(response.data));
    } catch (error) {
      console.error("Error submitting vendor form: ", error);
      return new Promise((reject) => reject(error));
    }
  };

  const postNewsLetter = async (data) => {
    try {
      const response = await apiClient.post("/Emails/newsletter", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return new Promise((resolve) => resolve(response.data));
    } catch (error) {
      console.error("Error submitting newsLetter: ", error);
      return new Promise((reject) => reject(error));
    }
  };

  const postProductReport = async (data) => {
    try {
      const response = await apiClient.post("/Emails/report", data);
      return response.data;
    } catch (error) {
      console.error("Error sending product report: ", error);
      throw error;
    }
  };

  return {
    getListings,
    getCalibers,
    getBrands,
    getSearch,
    getCaliberSEO,
    getProductSEO,
    getBrandSEO,
    getBrandCaliberSEO,
    getProducts,
    getGroupListings,
    getPriceHistory,
    postMessage,
    postProductReport,
    postVendorForm,
    postNewsLetter,
  };
};

export default useHttp;
